<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card card-default">
          <div class="card-body text-center">
            <br>Processing logout...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  mounted () {
    this.submit()
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    submit () {
      this.$loading.startLoading('logging-out')
      this.logout()
        .then(() => {
          this.$loading.endLoading('logging-out')
          this.$router.replace('/login')
        })
        .catch(() => {
          this.$loading.endLoading('logging-out')
        })
    }
  }
}
</script>
